import React, { Component } from 'react';
import { isEqual } from 'lodash';

import OneOfOptions from './OneOfOptions';
import Question from './Question';
import { TranslatedNameType, ExtendedTranslatedNameType } from '../../../redux/types';

type OneOfPropType = {
  question: ExtendedTranslatedNameType;
  options: ExtendedTranslatedNameType[];
  numCases: number;
  startCase: number;
  onSamplePayloadChanged: (a: string, b: number, c: AnswerType | null) => void;
  answerPayload: {
   answers: AnswerType[];
  };
  defaultOption: TranslatedNameType;
  incomplete? : boolean;
  disabled?: boolean;
}

type AnswerType = {
  type: string;
  answer: string;
};

export default class OneOf extends Component<OneOfPropType> {
  shouldComponentUpdate(nextProps: OneOfPropType): boolean {
    const current = this.props.answerPayload;
    return !isEqual(current, nextProps.answerPayload)
    || !isEqual(this.props.incomplete, nextProps.incomplete)
    || !isEqual(this.props.question.highlight, nextProps.question.highlight)
    || !isEqual(this.props.options, nextProps.options)
    || !isEqual(this.props.disabled, nextProps.disabled);
  }

  getOneOf = (sampleIndex: number): string => (
    this.props.answerPayload
      && this.props.answerPayload.answers[sampleIndex]
        && this.props.answerPayload.answers[sampleIndex].answer
  );

  render(): React.ReactNode {
    const {
      question,
      options,
      startCase,
      defaultOption,
      incomplete,
      disabled,
    } = this.props;
    return (
      <form>
        <Question
          question={question.text}
          incomplete={incomplete}
          highlight={question.highlight}
          uuid={question.uuid}
        />
        <OneOfOptions
          options={options}
          startCase={startCase}
          onRadioButtonChange={(optionId: string, sampleIndex: number): void => {
            this.props.onSamplePayloadChanged(
              this.props.question.uuid,
              sampleIndex,
              optionId !== undefined ? { type: 'OneOf', answer: optionId } : null,
            );
          }}
          getOneOf={this.getOneOf}
          numCases={this.props.numCases}
          defaultOption={defaultOption}
          disabled={disabled}
        />
      </form>
    );
  }
}
